import { getEWSRequestBodyTemplate, getMIMEBodyTemplate } from './helpers';

export const getMailMIME = (
  mailId: string,
  callback: (result: Office.AsyncResult<string>) => void,
) => {
  const requestBody = getEWSRequestBodyTemplate(getMIMEBodyTemplate(mailId));
  Office.context.mailbox.makeEwsRequestAsync(requestBody, callback);
};
